import { useLingui } from '@lingui/react/macro';

import {
  FilterCheckboxItem,
  FilterItemNoResults,
  FiltersList,
  FiltersSubMenu,
} from '@/design_system/Filters/FiltersDrawer/FiltersDrawer';
import IconTools from '@/icons/Tools.svg';

import { useFilters } from '../FiltersState';
import { useServiceTypeOptions } from '../utils';

export const FiltersServiceType = () => {
  const { t, i18n } = useLingui();

  const {
    serviceTypes: { serviceTypes, setServiceTypes },
  } = useFilters();

  const serviceTypeOptions = useServiceTypeOptions();

  const toggleServiceType = (serviceType: (typeof serviceTypes)[number]) => {
    if (serviceTypes.includes(serviceType)) {
      setServiceTypes(serviceTypes.filter((t) => t !== serviceType));
    } else {
      setServiceTypes([...serviceTypes, serviceType]);
    }
  };

  const options =
    serviceTypeOptions.length > 0 ? (
      serviceTypeOptions.map(({ id, label }) => (
        <FilterCheckboxItem key={id} id={id} label={i18n._(label)} />
      ))
    ) : (
      <FilterItemNoResults />
    );

  return (
    <FiltersSubMenu
      id="service-type"
      icon={<IconTools />}
      label={t({ id: 'requests.filters.service-type.label', message: 'Service type' })}
      count={serviceTypes.length}
    >
      <FiltersList
        ariaLabel={t({ id: 'requests.filters.service-type.label', message: 'Service type' })}
        values={serviceTypes}
        onChange={toggleServiceType}
      >
        {options}
      </FiltersList>
    </FiltersSubMenu>
  );
};
